import { useQuery } from 'react-query';
import api from 'config/api';
import requester from 'utils/requester';

export const KEY = 'USE_LOAD_BY_URL';

const apiCall = async (url) => {
  const data = await requester({
    method: 'get',
    url: `${api.host}${url}`,
  });

  return data;
};

const useLoadByUrl = (url = '', options) => {
  return useQuery([KEY, url], () => apiCall(url), { ...options });
};

export default useLoadByUrl;
